import { render, staticRenderFns } from "./DatosEntradasSinRecinto.vue?vue&type=template&id=03191500"
import script from "./DatosEntradasSinRecinto.vue?vue&type=script&lang=js"
export * from "./DatosEntradasSinRecinto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports